import { useEffect, useState } from "react";

import logo from '../../../assets/img/logo.png'
import { NavLink } from "react-router-dom";

const Header = ({ currentSection }) => {

    const [isScrolled, setIsScrolled] = useState(false);
    const [activeSection, setActiveSection] = useState(currentSection);

    const sections = ["home", "quienes-somos", "nuestros-servicios", "nuestro-equipo", "testimonios", "preguntas-frecuentes", "contacto"];

    const handleScroll = () => {

        const scrollTop = window.scrollY;
        const threshold = 50;
        if (scrollTop > threshold) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }

        const scrollPosition = window.scrollY + 100;

        sections.forEach((sectionId) => {
            const section = document.getElementById(sectionId);
            if (section) {
                const offsetTop = section.offsetTop;
                const sectionHeight = section.offsetHeight;

                if (scrollPosition >= offsetTop && scrollPosition < offsetTop + sectionHeight) {
                    setActiveSection(sectionId);
                }
            }
        });
    };

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleClick = ({
        phone = "16892589039",
        message = "Hola, quiero más información",
    }) => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;

        const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

        // URL de WhatsApp
        const whatsappURL = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}&app_absent=0`;

        // En iOS Safari, abrir directamente
        if (isIOS) {
            window.location.href = whatsappURL;
        } else {
            window.open(whatsappURL, "_blank", "noopener,noreferrer");
        }
    };

    return (
        <div className="fixedArea">
            <div className="top-bar-mobile d-block d-md-none">
                <div className="container">
                    <div className="d-flex justify-content-center align-items-center gap-2">
                        <a href="tel:+16892589039" className="phone-link-blue fw-bold text-decoration-none">
                            +1 (689) 258-9039
                        </a>
                    </div>
                </div>
            </div>
            <nav className={`navbar myNavBar navbar-expand-lg navbar-dark bg-transparent ${isScrolled ? "active" : ""}`}>
                <div className="container">
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                        {/* Mobile */}
                        <a href="/" ><img className="d-block d-md-none" src={logo} alt="" width="40" height="35" /></a>
                        <a className="navbar-brand d-block d-md-none" style={{ fontSize: "15px"}} href="/">Asilo a tu alcance</a>
                        {/* Desktop */}
                        <a href="/" ><img className="d-none d-md-block" src={logo} alt="" width="60" height="50" /></a>
                        <a className="navbar-brand fs-6 d-none d-md-block" href="/">Asilo a tu alcance</a>
                    </div>
                    <button className="navbar-toggler shadow-none border-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="sidebar offcanvas offcanvas-start" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                        <div className="offcanvas-header text-white border-bottom">
                            <div className='d-flex flex-column justify-content-center align-items-center text-center'>
                                <img className="" src={logo} alt="" width="60" height="50" />
                            </div>
                            <button type="button" className="btn-close btn-close-white shadow-none" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        {/* Top bar */}
                        <div className="top-bar d-none d-md-block">
                            <div className="container">
                                <div className="d-flex justify-content-end align-items-center gap-2">
                                    <a href="tel:+16892589039" className="phone-link fw-bold text-decoration-none">
                                        +1 (689) 258-9039
                                    </a>
                                    <button onClick={handleClick}
                                        className="border-0 px-3 text-white rounded-2 py-2 border-0"
                                        style={{ background: "#c12a21"}}
                                    >
                                        Evaluamos tu caso sin costo
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="offcanvas-body d-flex flex-column flex-lg-row p-4 p-lg-0">
                            <ul className="navbar-nav justify-content-center align-items-center flex-grow-1 pe-3" style={{ fontSize: '1.1em !important' }}>
                                <li className="navbar-landing  nav-item mx-1">
                                    <a className={`nav-link ${activeSection === 'home' ? "active" : ""}`} aria-current="page" href="/#home">Inicio</a>
                                </li>
                                <li className="navbar-landing  nav-item mx-1">
                                    <a className={`nav-link ${activeSection === 'nuestro-equipo' ? "active" : ""}`} href="/#nuestro-equipo">Nuestro Equipo</a>
                                </li>
                                <li className="navbar-landing  nav-item mx-1">
                                    <a className={`nav-link ${activeSection === 'preguntas-frecuentes' ? "active" : ""}`} href="/#preguntas-frecuentes">Preguntas Frecuentes</a>
                                </li>
                                <li className="navbar-landing  nav-item mx-1">
                                    <NavLink className={`nav-link`} to={`/financiacion`}>Financiación</NavLink>
                                </li>
                                <li className="navbar-landing  nav-item mx-1">
                                    <NavLink className={`nav-link`} to={`/contacto`}>Contáctanos</NavLink>
                                </li>
                                <li className="navbar-landing  nav-item mx-1">
                                    <NavLink className={`nav-link`} to={`/formulario`}>Formulario</NavLink>
                                </li>
                            </ul>
                            {/* <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center gap-3">
                                <NavLink to={`/login`} target="_blank" className={`text-white text-decoration-none px-3 py-1 rounded-4`} style={{ backgroundColor: '#B1802D' }}>Iniciar sesión</NavLink>
                            </div> */}
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default Header;